// eslint-disable-next-line import/no-anonymous-default-export
export default
{
    ID: 'ze-snippet',
    PATH: 'https://static.zdassets.com/ekr/snippet.js?key=ffffc82d-fecc-4c1e-a98d-fd3553ffeb2e',
    MESSAGING_PATH: 'https://static.zdassets.com/ekr/snippet.js?key=1e6f2402-80bc-47be-a2dc-2dd8601fede3',
    TOKEN_PATH: '/sys/api/zendeskauth',
};
